import { Box, Card, CardContent, SxProps, Typography } from '@mui/material';
import React from 'react';
import SimulatorAvatar from '../simulator-avatar/SimulatorAvatar';
import { ExerciseType, SimulatorType } from '../types';

export interface SimulatorCardProps {
  adHoc: boolean;
  exerciseType: ExerciseType;
  name: string;
  simulatorType: SimulatorType;
  sx?: SxProps;
}

const SimulatorCard = ({ adHoc, exerciseType, name, simulatorType, sx = {} }: SimulatorCardProps) => (
  <Card sx={{ backgroundColor: theme => theme.palette.background.default, ...sx }}>
    <CardContent sx={{ display: 'flex', gap: 2 }}>
      <SimulatorAvatar
        adHoc={adHoc}
        exerciseType={exerciseType}
        simulatorType={simulatorType}
        sx={{ height: 69, width: 69 }}
      />
      <Box sx={{ flex: 1, alignSelf: 'center' }}>
        <Typography variant="overline">Simulator</Typography>
        <Typography>{name}</Typography>
      </Box>
    </CardContent>
  </Card>
);

export default SimulatorCard;
